// extracted by mini-css-extract-plugin
module.exports = {"sliderWrapper":"slider_sliderWrapper__CPeek"};